import React, { useState } from 'react';
import AuthForm from './AuthForm';
import ForgotPasswordScreen from './ForgotPasswordScreen';
import { User } from '../types';

interface LoginScreenProps {
    onLoginSuccess: (user: User) => void;
    onShowPrivacyPolicy: () => void;
    loginError?: string | null;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ onLoginSuccess, onShowPrivacyPolicy, loginError = null }) => {
    const [isLoginView, setIsLoginView] = useState(true);
    const [isForgotPassword, setIsForgotPassword] = useState(false);

    if (isForgotPassword) {
        return <ForgotPasswordScreen onBackToLogin={() => setIsForgotPassword(false)} />;
    }

    return (
        <div className="bg-white dark:bg-slate-800 p-8 rounded-lg shadow-2xl text-center flex flex-col items-center animate-fade-in w-full max-w-md mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                {isLoginView ? 'Acesse a Plataforma' : 'Crie sua Conta'}
            </h2>
            <p className="text-gray-600 dark:text-slate-300 mb-8">
                {isLoginView ? 'Use seu e-mail e senha para entrar.' : 'Preencha os dados para começar a estudar.'}
            </p>

            <AuthForm
                isLoginView={isLoginView}
                onLoginSuccess={onLoginSuccess}
                onRegisterSuccess={() => setIsLoginView(true)}
                onShowPrivacyPolicy={onShowPrivacyPolicy}
                externalError={loginError} // Pass the external error
            />

            <div className="mt-6 text-sm w-full flex justify-between">
                {isLoginView && (
                    <button
                        onClick={() => setIsForgotPassword(true)}
                        className="font-medium text-orange-500 hover:text-orange-400"
                    >
                        Esqueci minha senha
                    </button>
                )}
                <button
                    onClick={() => setIsLoginView(!isLoginView)}
                    className={`font-medium text-orange-500 hover:text-orange-400 ${isLoginView ? 'text-right' : 'mx-auto'}`}
                >
                    {isLoginView ? 'Não tem uma conta? Cadastre-se' : 'Já tem uma conta? Faça o login'}
                </button>
            </div>
        </div>
    );
};

export default LoginScreen;